import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Selector = props => (
  <div className="lr-myperformance-graph-tab">
    <button
      className={`${props.selectedQuarter === 1 ? 'lr-active' : ''}`}
      disabled={!props.enabledQuarters && props.currentQuarter < 1}
      onClick={() => props.handleQuarterSelection(1)}
    >
      {moment().month(0).format('MMM')} - {moment().month(2).format('MMM')}
    </button>
    <button
      className={`${props.selectedQuarter === 2 ? 'lr-active' : ''}`}
      disabled={!props.enabledQuarters && props.currentQuarter < 2}
      onClick={() => props.handleQuarterSelection(2)}
    >
      {moment().month(3).format('MMM')} - {moment().month(5).format('MMM')}
    </button>
    <button
      className={`${props.selectedQuarter === 3 ? 'lr-active' : ''}`}
      disabled={!props.enabledQuarters && props.currentQuarter < 3}
      onClick={() => props.handleQuarterSelection(3)}
    >
      {moment().month(6).format('MMM')} - {moment().month(8).format('MMM')}
    </button>
    <button
      className={`${props.selectedQuarter === 4 ? 'lr-active' : ''}`}
      disabled={!props.enabledQuarters && props.currentQuarter < 4}
      onClick={() => props.handleQuarterSelection(4)}
    >
      {moment().month(9).format('MMM')} - {moment().month(11).format('MMM')}
    </button>
  </div>
);

Selector.propTypes = {
  handleQuarterSelection: PropTypes.func.isRequired,
  selectedQuarter: PropTypes.number.isRequired,
  currentQuarter: PropTypes.number.isRequired,
  enabledQuarters: PropTypes.bool.isRequired,
};

export default Selector;
